import { Status } from "../todo-list.types.js";
const isTodoDone = (status) => status === Status.DONE || status === Status.IGNORED || status === Status.RECALLED;
export {
  isTodoDone
};
